import React from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
  children: JSX.Element;
}

export default function PublicRoute(props: PublicRouteProps): JSX.Element {
  const isAuthenticated = true;

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return props.children;
}
